/* @flow */

import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';

import { createCustomNetworkErrorFromKey } from '../../../../libs/netgemLibrary/helpers/CreateCustomNetworkError';
import { REDUX_MSG_REQUEST_BO_FAVORITE_ADD } from '../../constants';
import getFavoriteList from './favoriteList';
import getRequestDetails from './helpers/requestCommon';
import { BO_API_ADD_FAVORITE } from './types/common';

const addToFavoriteList: (titId: string, signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (titId, signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<void> => {
    const {
      appConfiguration: { mainDistributorId },
    } = getState();

    if (!mainDistributorId) {
      return Promise.reject(
        createCustomNetworkErrorFromKey('common.messages.errors.missing_parameters_list', {
          list: 'mainDistributorId',
          name: 'Add to favorite list',
        }),
      );
    }

    // Object 'requestDetails' contains 'headers', 'method' and 'uri' parameters
    const requestDetails = getRequestDetails(getState, mainDistributorId, BO_API_ADD_FAVORITE);

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_BO_FAVORITE_ADD, {
      ...requestDetails,
      signal,
      titId,
    }).then(() => dispatch(getFavoriteList(signal)));
  };

export default addToFavoriteList;
